(function () {
  'use strict';

  var COOKIE = 'maycelineCartReserveEnd';
  var DURATION_MS = 10 * 60 * 1000;
  var ticker = null;
  var cartFetch = null;
  var lastCartJson = null;

  function readCookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function writeCookie(name, value, days) {
    var expires = new Date(Date.now() + days * 864e5).toUTCString();
    document.cookie =
      name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
  }

  function formatMMSS(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var minutes = Math.floor(total / 60);
    var seconds = total % 60;
    return String(minutes).padStart(2, '0') + ':' + String(seconds).padStart(2, '0');
  }

  function tickReserve() {
    var el = document.getElementById('cart-reserve-timer');
    if (!el) return;
    var end = Number(readCookie(COOKIE));
    if (!end || end <= Date.now()) {
      end = Date.now() + DURATION_MS;
      writeCookie(COOKIE, end, 1);
    }
    el.textContent = formatMMSS(end - Date.now());
  }

  function startReserveTimer() {
    if (!document.getElementById('cart-reserve-timer')) return;
    tickReserve();
    if (ticker) clearInterval(ticker);
    ticker = setInterval(tickReserve, 1000);
  }

  function moneyFromCents(cents, currency) {
    var amount = (Number(cents) / 100).toFixed(2);
    var code = (currency || (lastCartJson && lastCartJson.currency) || window.Shopify && Shopify.currency && Shopify.currency.active || 'USD').toUpperCase();
    var symbols = { USD: '$', EUR: '€', GBP: '£', CAD: 'CA$', AUD: 'A$', NZD: 'NZ$' };
    var sym = symbols[code] || (code + ' ');
    return sym + amount;
  }

  function applyCartToRewards(cart) {
    if (!cart) return;
    lastCartJson = cart;
    var giftsList = document.querySelector('#cart-drawer .gifts__list');
    if (!giftsList) return;

    var cartTotal = cart.total_price;
    giftsList.dataset.total = String(cartTotal);

    var gifts = Array.from(document.querySelectorAll('#cart-drawer .gift'));
    var thresholds = [];

    gifts.forEach(function (gift) {
      var amount = parseFloat(gift.dataset.total);
      var titleEl = gift.querySelector('.gift__title h6');
      var name = titleEl ? titleEl.textContent.trim() : '';
      if (cartTotal >= amount) gift.classList.add('active');
      else gift.classList.remove('active');
      if (!isNaN(amount)) thresholds.push({ amount: amount, name: name });
    });

    thresholds.sort(function (a, b) {
      return a.amount - b.amount;
    });

    var nextThreshold = null;
    for (var i = 0; i < thresholds.length; i++) {
      if (cartTotal < thresholds[i].amount) {
        nextThreshold = thresholds[i];
        break;
      }
    }

    var progressBar = document.querySelector('#cart-drawer .gifts_bar');
    if (progressBar) {
      if (nextThreshold) {
        var remaining = nextThreshold.amount - cartTotal;
        progressBar.innerHTML =
          '<p>Spend <strong>' +
          moneyFromCents(remaining, cart.currency || (lastCartJson && lastCartJson.currency)) +
          '</strong> more for <strong>' +
          nextThreshold.name +
          '</strong></p>';
      } else if (cartTotal > 0 || thresholds.length) {
        progressBar.innerHTML = '<p>🎉 You have unlocked all rewards!</p>';
      }
    }

    // Hide watch upsell slides already in cart (product_id match)
    var ids = (cart.items || []).map(function (it) {
      return String(it.product_id);
    });
    document.querySelectorAll('#cart-drawer [data-watch-upsell-slide]').forEach(function (slide) {
      var pid = slide.getAttribute('data-product-id');
      if (pid && ids.indexOf(pid) !== -1) slide.remove();
    });
  }

  function fetchCartOnce() {
    if (cartFetch) return cartFetch;
    cartFetch = fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        applyCartToRewards(cart);
        return cart;
      })
      .catch(function () {
        /* ignore */
      })
      .then(function (cart) {
        cartFetch = null;
        return cart;
      });
    return cartFetch;
  }

  function updateRewardsBar() {
    // Prefer total already painted by CartItems when available
    var totalEl = document.querySelector('#cart-drawer [data-cart-total]');
    var attr = totalEl && totalEl.getAttribute('data-cart-total');
    if (attr !== null && attr !== '' && !isNaN(Number(attr))) {
      applyCartToRewards({
        total_price: Number(attr),
        items: (lastCartJson && lastCartJson.items) || [],
      });
      // Still refresh items list lightly when drawer opens / cart changes
      fetchCartOnce();
      return;
    }
    fetchCartOnce();
  }

  function onReady() {
    startReserveTimer();
    updateRewardsBar();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      if (ticker) {
        clearInterval(ticker);
        ticker = null;
      }
    } else if (!ticker) {
      startReserveTimer();
      updateRewardsBar();
    }
  });

  // Event-driven only — no 2s polling (that fought qty/ADD updates)
  document.addEventListener('theme:cart:change', updateRewardsBar);
  document.addEventListener('theme:cart:refresh', function () {
    window.setTimeout(updateRewardsBar, 50);
  });
  document.addEventListener('theme:product:added', updateRewardsBar);
  document.addEventListener('theme:cart-drawer:open', updateRewardsBar);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady, { once: true });
  } else {
    onReady();
  }
})();
